module.exports = __webpack_public_path__ + "img/interface-screen-6.a9f1bbd.jpg";